/* tslint:disable */
/* eslint-disable */
/**
 * NN.CustomerPortal.ApiApp.General
 * GeneralAPIs
 *
 * The version of the OpenAPI document: 1.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FufiContributionType } from './FufiContributionType';
import {
    FufiContributionTypeFromJSON,
    FufiContributionTypeFromJSONTyped,
    FufiContributionTypeToJSON,
    FufiContributionTypeToJSONTyped,
} from './FufiContributionType';
import type { FufiPaymentType } from './FufiPaymentType';
import {
    FufiPaymentTypeFromJSON,
    FufiPaymentTypeFromJSONTyped,
    FufiPaymentTypeToJSON,
    FufiPaymentTypeToJSONTyped,
} from './FufiPaymentType';

/**
 * 
 * @export
 * @interface FufiFinancialInfoQuery
 */
export interface FufiFinancialInfoQuery {
    /**
     * 
     * @type {number}
     * @memberof FufiFinancialInfoQuery
     */
    moneyInsPageSize?: number | null;
    /**
     * 
     * @type {number}
     * @memberof FufiFinancialInfoQuery
     */
    moneyInsPage?: number | null;
    /**
     * 
     * @type {Date}
     * @memberof FufiFinancialInfoQuery
     */
    moneyInsFrom?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof FufiFinancialInfoQuery
     */
    moneyInsTo?: Date | null;
    /**
     * 
     * @type {number}
     * @memberof FufiFinancialInfoQuery
     */
    premiumsPageSize?: number | null;
    /**
     * 
     * @type {number}
     * @memberof FufiFinancialInfoQuery
     */
    premiumsPage?: number | null;
    /**
     * 
     * @type {Date}
     * @memberof FufiFinancialInfoQuery
     */
    premiumsFrom?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof FufiFinancialInfoQuery
     */
    premiumsTo?: Date | null;
    /**
     * 
     * @type {Array<FufiContributionType>}
     * @memberof FufiFinancialInfoQuery
     */
    moneyInsPayerTypes?: Array<FufiContributionType> | null;
    /**
     * 
     * @type {Array<FufiPaymentType>}
     * @memberof FufiFinancialInfoQuery
     */
    moneyInsPaymentTypes?: Array<FufiPaymentType> | null;
}

/**
 * Check if a given object implements the FufiFinancialInfoQuery interface.
 */
export function instanceOfFufiFinancialInfoQuery(value: object): value is FufiFinancialInfoQuery {
    return true;
}

export function FufiFinancialInfoQueryFromJSON(json: any): FufiFinancialInfoQuery {
    return FufiFinancialInfoQueryFromJSONTyped(json, false);
}

export function FufiFinancialInfoQueryFromJSONTyped(json: any, ignoreDiscriminator: boolean): FufiFinancialInfoQuery {
    if (json == null) {
        return json;
    }
    return {
        
        'moneyInsPageSize': json['moneyInsPageSize'] == null ? undefined : json['moneyInsPageSize'],
        'moneyInsPage': json['moneyInsPage'] == null ? undefined : json['moneyInsPage'],
        'moneyInsFrom': json['moneyInsFrom'] == null ? undefined : (new Date(json['moneyInsFrom'])),
        'moneyInsTo': json['moneyInsTo'] == null ? undefined : (new Date(json['moneyInsTo'])),
        'premiumsPageSize': json['premiumsPageSize'] == null ? undefined : json['premiumsPageSize'],
        'premiumsPage': json['premiumsPage'] == null ? undefined : json['premiumsPage'],
        'premiumsFrom': json['premiumsFrom'] == null ? undefined : (new Date(json['premiumsFrom'])),
        'premiumsTo': json['premiumsTo'] == null ? undefined : (new Date(json['premiumsTo'])),
        'moneyInsPayerTypes': json['moneyInsPayerTypes'] == null ? undefined : ((json['moneyInsPayerTypes'] as Array<any>).map(FufiContributionTypeFromJSON)),
        'moneyInsPaymentTypes': json['moneyInsPaymentTypes'] == null ? undefined : ((json['moneyInsPaymentTypes'] as Array<any>).map(FufiPaymentTypeFromJSON)),
    };
}

export function FufiFinancialInfoQueryToJSON(json: any): FufiFinancialInfoQuery {
    return FufiFinancialInfoQueryToJSONTyped(json, false);
}

export function FufiFinancialInfoQueryToJSONTyped(value?: FufiFinancialInfoQuery | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'moneyInsPageSize': value['moneyInsPageSize'],
        'moneyInsPage': value['moneyInsPage'],
        'moneyInsFrom': value['moneyInsFrom'] === null ? null : ((value['moneyInsFrom'] as any)?.toISOString()),
        'moneyInsTo': value['moneyInsTo'] === null ? null : ((value['moneyInsTo'] as any)?.toISOString()),
        'premiumsPageSize': value['premiumsPageSize'],
        'premiumsPage': value['premiumsPage'],
        'premiumsFrom': value['premiumsFrom'] === null ? null : ((value['premiumsFrom'] as any)?.toISOString()),
        'premiumsTo': value['premiumsTo'] === null ? null : ((value['premiumsTo'] as any)?.toISOString()),
        'moneyInsPayerTypes': value['moneyInsPayerTypes'] == null ? undefined : ((value['moneyInsPayerTypes'] as Array<any>).map(FufiContributionTypeToJSON)),
        'moneyInsPaymentTypes': value['moneyInsPaymentTypes'] == null ? undefined : ((value['moneyInsPaymentTypes'] as Array<any>).map(FufiPaymentTypeToJSON)),
    };
}

